import React, { AriaAttributes, ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';
import Color from 'color';

export const BaseButton = styled.button.attrs({ tabIndex: 0 })`
  color: ${(props) => Color(props.theme.colors.primary_active)
    .alpha(0.65)
    .lighten(0.5)
    .string()};
  cursor: pointer;
  margin: 0.25rem;
  &:disabled {
    cursor: not-allowed;
  }
  &:focus {
    outline: 1px solid var(color);
    outline-offset: 2px;
  }
  &::-moz-focus-inner {
    border: 0;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/FiveStarSurvey/components/BaseButton.tsx